var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('discount Rates'),"description":_vm.$t('from Here You Can Control The Units Of The Discount Rates')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Search For A Discount Rate'),"emptyTableText":_vm.$t('there Are No Discount Rates'),"localData":true,"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"buttonRole":true,"cloumns":[
          {
            column: 'name',
            title: _vm.$t('Name The discount rate'),
            type: 'text',
            sort: true
          },
          {
            column: 'rate',
            title: _vm.$t('Discount rate'),
            type: 'text',
            sort: true,
            after: '%'
          },
          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'edit', role: true },
              { name: 'delete', role: true }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }